(function () {
  'use strict';

  angular.module('app').component('teamMemberDetail', teamMemberDetail());

  function teamMemberDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        fast: '<',
        hideTopControls: '<',
        onSavedItem: '&',
        onCanceledItem: '&',
      },
      controller: TeamMemberDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/team-members/team-member-detail/team-member-detail.component.html',
    };
  }

  TeamMemberDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    '$location',
    'TeamMemberService',
    'SessionService',
    'LanguageService',

    // Angular downgraded service
    'countryService',
    'companyService',
  ];

  function TeamMemberDetailComponent(
    config,
    UtilService,
    $location,
    TeamMemberService,
    SessionService,
    LanguageService,

    // Angular downgraded service
    countryService,
    companyService
  ) {
    const vm = this;

    vm.UtilService = new UtilService(vm);

    let cropedImage = { file: null };

    vm.activeStatus = config.ACTIVE;
    vm.inactiveStatus = config.INACTIVE;

    vm.teamMembers = [];
    vm.loadingTeamMembers = false;
    vm.teamMemberSelected = null;

    // Methods
    vm.selectCountry = selectCountry;
    vm.selectTaxIdType = selectTaxIdType;
    vm.selectState = selectState;
    vm.selectCity = selectCity;
    vm.selectCountryPhone = selectCountryPhone;
    vm.selectCountrySecondaryPhone = selectCountrySecondaryPhone;
    vm.selectCountryMobile = selectCountryMobile;
    vm.selectUser = selectUser;

    vm.editTeamMember = editTeamMember;
    vm.cancelEdit = cancelEdit;
    vm.openLogo = openLogo;
    vm.saveTeamMember = saveTeamMember;
    vm.cancel = cancel;

    vm.selectTeamMember = selectTeamMember;
    vm.goToOtherTeamMember = goToOtherTeamMember;

    vm.onShowProvider = onShowProvider;
    vm.onShowClient = onShowClient;
    vm.onShowUser = onShowUser;

    let companyId = SessionService.getSelectedAccountCompany().id;
    let userLanguageCode = SessionService.getUserLanguage().code;

    vm.$onInit = function () {
      if (vm.item.id) {
        // Edit
        setItemOptions(vm.item, vm.mode);
        getTaxIdTypesByCountry(vm.item.country);
        
        getTeamMembers();
      } else {
        vm.createMode = true;

        vm.item = {
          is_provider: false,
          is_client: false,
        };

        vm.labelAddLogo = 'ADD_PHOTO';
        vm.stateLabel = 'STATE';
        vm.cityLabel = 'CITY';

        // Initializers
        getCountries();
      }

      // Initializers
      getCompany();
      getLanguages();
    };

    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') editTeamMember();

      vm.countrySelected = item.country;
      vm.isCostaRicaSelected = vm.countrySelected && vm.countrySelected.code === 'CR';
      if (vm.countrySelected) setCountryStatesLabels(vm.countrySelected);

      vm.item.is_provider = vm.item.is_provider === undefined ? false : vm.item.is_provider;
      vm.item.is_client = vm.item.is_client === undefined ? false : vm.item.is_client;

      vm.itemName = `${item.name} ${item.last_name}`;
      vm.labelAddLogo = item.logo.url ? 'CHANGE_PHOTO' : 'ADD_PHOTO';
      vm.originalItem = angular.copy(item);
    }

    function editTeamMember() {
      vm.editMode = true;
      vm.viewMode = false;

      // Initializers
      getCountries();
      setCountryStatesLabels(vm.item.country);
      getCountryStates(vm.item.country);
    }

    function cancelEdit() {
      if (vm.originalItem.country_id !== vm.item.country_id)
        getTaxIdTypesByCountry(vm.originalItem.country);

      vm.item = vm.originalItem;
      setItemOptions(vm.item);
    }

    function getCompany() {
      vm.loadingCompany = true;
      companyService
        .getCompany(companyId, { skip_check_role: true, lang: userLanguageCode })
        .subscribe((response) => {
          vm.company = response;
          vm.users = vm.company.users;

          getUser();

          if (vm.createMode) {
            vm.country = vm.countries.find((item) => item.code === vm.company.country.code);
            vm.item.country_id = vm.country.id;

            selectCountry(vm.country);
          }

          vm.loadingCompany = false;
        });
    }

    function getCountries() {
      if (vm.countries) return;

      vm.loadingCountries = true;
      countryService
        .getCountries({ get: 'active', skip_check_role: true })
        .subscribe((response) => {
          vm.countries = response;

          if (!vm.createMode && vm.item.phone_code) {
            let countryPhone = vm.countries.find((item) => item.phone_code === vm.item.phone_code);
            selectCountryPhone(countryPhone);
          }

          vm.loadingCountries = false;
        });
    }

    function getStatesByCountry() {
      const params = {
        get: 'active',
        skip_check_role: true,
      };

      countryService.getStates(vm.item.country_id, params).subscribe((response) => {
        vm.statesByCountry = response;
      });
    }

    function getCitiesByState(state_id) {
      const params = {
        get: 'active',
        by_state: state_id,
        skip_check_role: true,
      };

      countryService.getCities(vm.item.country_id, params).subscribe((response) => {
        vm.citiesByState = response;
      });
    }

    function getDistrictsByCity(city_id) {
      const params = {
        get: 'active',
        by_city: city_id,
        skip_check_role: true,
      };

      countryService.getDistricts(vm.item.country_id, params).subscribe((response) => {
        vm.districtsByCity = response;
      });
    }

    // Form methods

    function selectCountry(country) {
      if (vm.countrySelected && vm.countrySelected.id === country.id) return;

      vm.item.tax_id_number = null;
      vm.item.district_id = null;
      vm.item.tax_id_code = null;
      vm.countrySelected = country;
      vm.isCostaRicaSelected = country.code === 'CR';
      vm.item.last_name = null;
      vm.item.state_id = null;
      vm.item.city_id = null;
      vm.taxIdType = null;

      if (!vm.item.phone_number) {
        selectCountryPhone(country);
        vm.item.phone_code = country.phone_code;
      }

      getTaxIdTypesByCountry(country);
      setCountryStatesLabels(country);
      getCountryStates(country);
    }

    function selectTaxIdType(taxIdType) {
      vm.item.legal_id = null;
      vm.taxIdType = taxIdType;
    }

    function selectState(state_id) {
      vm.item.city_id = null;
      vm.item.district_id = null;
      getCitiesByState(state_id);
    }

    function selectCity(city_id) {
      vm.item.district_id = null;
      getDistrictsByCity(city_id);
    }

    function selectCountryPhone(country) {
      vm.countryPhoneSelected = country;
    }

    function selectCountrySecondaryPhone(country) {
      vm.countrySecondaryPhoneSelected = country;
    }

    function selectCountryMobile(country) {
      vm.countryMobileSelected = country;
    }

    function setCountryStatesLabels(country) {
      vm.stateLabel = 'STATE';
      vm.cityLabel = 'CITY';
      if (country.enable_states) {
        vm.stateLabel = 'PROVINCE';
        vm.cityLabel = 'CANTON';
      }
    }

    function getCountryStates(country) {
      if (country.enable_states) {
        getStatesByCountry();

        if (vm.item.state_id) getCitiesByState(vm.item.state_id);
        if (vm.item.city_id) getDistrictsByCity(vm.item.city_id);
      }
    }

    function getTaxIdTypesByCountry(country) {
      const params = {
        skip_check_role: true,
        country_code: country.code,
        lang: userLanguageCode,
      };

      vm.loadingTaxIdTypes = true;
      countryService.getTaxIdTypesByCountry(params).subscribe((response) => {
        if (country.code !== 'CR') {
          vm.taxIdTypesByCountry = response.filter((taxIdType) => {
            return taxIdType.value === 'company' || taxIdType.value === 'individual';
          });
        } else {
          vm.taxIdTypesByCountry = response;
        }

        vm.taxIdType = response.find((item) => item.code === vm.item.tax_id_code);

        vm.loadingTaxIdTypes = false;
      });
    }

    function openLogo() {
      let logoSaved = (cropedImageObj) => {
        cropedImage = cropedImageObj;

        if (vm.editMode) {
          TeamMemberService.updateLogo(vm.item, cropedImage);
        } else {
          var img = document.getElementById('logo-image-preview'); // <HTMLInputElement>
          img.src = URL.createObjectURL(cropedImage.file);
        }
      };

      TeamMemberService.openLogo(vm.item, logoSaved);
    }

    // Create/Update
    function saveTeamMember(isFormValid) {
      vm.formErrors = false;

      let to = vm.hideTopControls ? 'teamMember' : '';

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        vm.UtilService.scrollToTop(to);

        return;
      }

      // Do not send relations
      let item = angular.copy(vm.item);
      delete item.country;
      delete item.contacts;

      createTeamMember(item, cropedImage, to);
    }

    function createTeamMember(item, cropedImage, to) {
      vm.sendingForm = true;
      TeamMemberService.saveTeamMember(item, cropedImage).then(
        function (response) {
          let data = response.data;

          if (!vm.editMode) {
            // Create
            vm.onSavedItem({ item: data });
          } else {
            // Edit
            vm.item = data; // reload item
            setItemOptions(data);

            vm.UtilService.scrollToTop(to);
          }

          getUser();

          vm.sendingForm = false;
        },
        function (response) {
          vm.serverErrors = vm.UtilService._showItemServerErrors(response.data.errors);
          vm.formErrors = true;
          vm.UtilService.scrollToTop(to);

          vm.sendingForm = false;
        }
      );
    }

    function cancel() {
      vm.onCanceledItem({ item: vm.item });
    }

    function selectTeamMember(teamMemberId) {
      if (!teamMemberId || (vm.item && vm.item.id === teamMemberId)) {
        return;
      }

      $location.path(`/team_members/${teamMemberId}`);
    }

    function goToOtherTeamMember(teamMemberId) {
      const teamMember = vm.teamMembers.find((tm) => tm.id === teamMemberId);
      selectTeamMember(teamMember.id);
    }

    function onShowProvider(id) {
      $location.path(`/providers/${id}`);
    }

    function onShowClient(id) {
      $location.path(`/clients/${id}`);
    }

    function onShowUser(id) {
      $location.path(`/users/${id}`);
    }

    function selectUser(user) {
      if (!user) return;

      vm.item.user_id = user.id;
    }

    function getLanguages() {
      if (vm.languages) return;

      LanguageService.getLanguages({ get: 'active', skip_check_role: true }).then(function (data) {
        vm.languages = data.items;
      });
    }

    function getUser() {
      if (vm.item.user_id)
        vm.item.user = vm.company.users.find((user) => user.id === vm.item.user_id);
    }

    function getTeamMembers() {
      const params = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
        per_page: 10000,
        company_id: companyId,
        skip_check_role: true,
      };

      vm.loadingTeamMembers = true;
      TeamMemberService.getTeamMembers(params)
        .then((response) => {
          if (!response) {
            vm.loadingTeamMembers = false;
            return;
          }

          const teamMembersData = response.items || [];

          if (!teamMembersData || !Array.isArray(teamMembersData)) {
            vm.loadingTeamMembers = false;
            return;
          }

          vm.teamMembers = [];

          teamMembersData.forEach((item, index) => {
            item.prev = teamMembersData[index - 1];
            item.next = teamMembersData[index + 1];

            vm.teamMembers.push(item);
          });

          setTeamMemberNavigation();
          vm.loadingTeamMembers = false;
        })
        .catch((error) => {
          console.error('Error loading team members:', error);
          vm.loadingTeamMembers = false;
        });
    }

    function setTeamMemberNavigation() {
      vm.teamMemberSelected = { ...vm.item };

      const teamMemberFound = vm.teamMembers.find((tm) => tm.id === vm.item.id);

      if (teamMemberFound) {
        vm.teamMemberSelected.prev = teamMemberFound.prev;
        vm.teamMemberSelected.next = teamMemberFound.next;
      }
    }
  }
})();
